import { generateListOfCopies, generateListOfWindings } from './generate-list'
import { getLowerColsStrategy } from './get-lower-cols-strategy'
import { getStrategy } from './get-strategy'

/**
 * 1 - наименование
 * 2 - количество копий
 */
export type LabelInfo = [string, number]

/**
 * Функция получения рекомендаций по намотке
 *
 * @param info
 * @param cols
 * @param winding
 * @returns
 */
export function getRecomendations(info: LabelInfo, cols: number, winding: number) {
    const [, copies] = info
    const [idealLowerWinding, idealUpperWinding] = generateListOfWindings(copies, cols, winding)
    const [idealLowerCopies, idealUpperCopies] = generateListOfCopies(winding, cols, copies)
    console.log('getRecomendations', info, cols, idealLowerWinding, idealUpperWinding)

    const lowerWindingStrategy = getStrategy(
        info,
        idealLowerWinding,
        cols,
        'Стратегия 1. Уменьшение намотки'
    )

    const upperWindingStrategy = getStrategy(
        info,
        idealUpperWinding,
        cols,
        'Стратегия 2. Увеличение намотки'
    )

    const lowerCopiesStrategy = getStrategy(
        [info[0], idealLowerCopies],
        winding,
        cols,
        'Стратегия 3. Уменьшение тиража'
    )

    const upperCopiesStrategy = getStrategy(
        [info[0], idealUpperCopies],
        winding,
        cols,
        'Стратегия 4. Увеличение тиража'
    )

    const edgeRollsStrategy = getStrategy(
        info, // инфо
        winding,
        cols,
        `Стратегия 5. Краевые ролики`
    )

    const lowerColsStrategy = getLowerColsStrategy(
        info,
        winding,
        cols,
        `Стратегия 6. Уменьшение ручьев`
    )

    return [
        lowerWindingStrategy,
        upperWindingStrategy,
        lowerCopiesStrategy,
        upperCopiesStrategy,
        edgeRollsStrategy,
        lowerColsStrategy,
    ]
}
